<template>
  <div>
    <Tool>
      <template v-slot:title>
        <h1 class="tool-title-h1">
          预约服务&nbsp;&nbsp;/&nbsp;&nbsp;用户预约
        </h1>
      </template>
      <template v-slot:content>
        <a-icon type="search" style="color: white; font-size: 20px"/>
        <a-input placeholder="查询账号,所有者,备注..." v-model="queryParam.searchValue" @change="search"
                 style="width: 250px; background-color: transparent; color: white; border: none">
        </a-input>
      </template>
      <template v-slot:tool>
        <a @click="handleTool" style="color: white; font-size: 20px;">
          <a-icon :type="toggleSeniorTool ? 'up' : 'filter'"/>
          <span style="font-size: 14px; margin-left: 5px; vertical-align: 2px;">{{
              toggleSeniorTool ? '收起工具' : '搜索工具'
            }}</span>
        </a>
      </template>
    </Tool>
    <div class="content">
      <a-row style="margin-bottom: 16px;" v-if="toggleSeniorTool">
        <a-col :span="4" :offset="20">
          <div>
            <a-date-picker style="width: 100%" placeholder="预约日期" v-model="queryParam.applicantDate"
                           value-format="YYYY-MM-DD" @change="search"/>
          </div>
        </a-col>
      </a-row>
      <div style="margin-bottom: 16px; display: flex; align-items: center; justify-content: space-between">
        <div>
          <a-button type="primary" icon="plus-circle" ghost @click="handleAdd">预约</a-button>
          <a-button type="primary" icon="minus-circle" :disabled="!hasSelected" @click="handleDeletes"
                    style="margin-left: 10px"
                    v-if="(username.indexOf('super') !== -1 || username === 'admin' || username === 'admin4')">
            批量删除
          </a-button>
        </div>
      </div>
      <a-table
          rowKey="id"
          :columns="columns"
          :data-source="dataSource"
          :pagination="pagination"
          :loading="loading"
          :scroll="{x: 1500}"
          bordered
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">
        <template slot="name" slot-scope="text, record">
          <template v-if="Number(record.bingCount) > 1">
            <a-tag :color="'orange'">
              {{ record.name }}
            </a-tag>
          </template>
          <template v-else>
            <span>{{ record.name }}</span>
          </template>
        </template>
        <template slot="status" slot-scope="status">
          <template v-if="status === '开始'">
            <a-icon type="info-circle" theme="twoTone" style="font-size: 18px" :title=status two-tone-color="orange"/>
          </template>
          <template v-if="status === '准备'">
            <a-icon type="right-circle" theme="twoTone" style="font-size: 18px" :title=status two-tone-color="#eb2f96"/>
          </template>
          <template v-if="status === '预约'">
            <a-icon type="clock-circle" theme="twoTone" :title=status style="font-size: 18px"/>
          </template>
          <template v-if="status === '成功'">
            <a-icon type="check-circle" theme="twoTone" style="font-size: 18px" :title=status
                    two-tone-color="#52c41a"/>
          </template>
          <template v-if="status === '暂停'">
            <a-icon type="pause-circle" theme="twoTone" style="font-size: 18px" :title=status two-tone-color="#fa541c"/>
          </template>
          <template v-if="status === '停止'">
            <a-icon type="stop" theme="twoTone" style="font-size: 18px" :title=status two-tone-color="#7f8c8d"/>
          </template>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item
                  v-if="(record.status === '开始') || (username.indexOf('super') !== -1 || username.indexOf('admin') !== -1)">
                <a @click="handleEdit(record)">编辑</a>
              </a-menu-item>
              <a-menu-item
                  v-if="(record.status === '开始') && (username.indexOf('super') !== -1 || username.indexOf('admin') !== -1)">
                <a @click="handleReady(record)">准备</a>
              </a-menu-item>
              <a-menu-item
                  v-if="(record.status === '准备') && (username.indexOf('super') !== -1 || username.indexOf('admin') !== -1)">
                <a @click="handleApply(record)">占用预约</a>
              </a-menu-item>
              <a-menu-item
                  v-if="(record.status === '开始' || record.status === '准备'|| record.status === '预约') && (username.indexOf('super') !== -1 || username.indexOf('admin') !== -1)">
                <a @click="handleStop(record)">停止</a>
              </a-menu-item>
              <a-menu-item
                  v-if="(record.status === '开始' || record.status === '准备' || record.status === '预约') && (username.indexOf('super') !== -1 || username.indexOf('admin') !== -1)">
                <a @click="handleFinish(record)">成功</a>
              </a-menu-item>
              <a-menu-item v-if="username.indexOf('super') !== -1 || username.indexOf('admin') !== -1">
                <a @click="handleInit(record)">初始化</a>
              </a-menu-item>
              <a-menu-item
                  v-if="(record.status === '开始' || record.status === '准备'|| record.status === '预约') && (username.indexOf('super') !== -1 || username.indexOf('admin') !== -1)">
                <a @click="handlePause(record)">暂停</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </a-table>
    </div>
    <create-modal ref="createModal" @ok="loadData"></create-modal>
  </div>
</template>

<script>

import Tool from '@/components/Tool.vue'
import {TableMixins} from '@/mixins/table-mixins'
import {HttpMixins} from '@/mixins/http-mixins'
import CreateModal from "@/components/usAppointment/CreateModal";
import debounce from "lodash/debounce";
import {ResponsiveMixins} from "@/mixins/responsive-mixins";

export default {
  name: 'UsAppointment',
  components: {
    CreateModal,
    Tool
  },
  mixins: [HttpMixins, TableMixins, ResponsiveMixins],
  data() {
    return {
      queryParam: {
        searchValue: ''
      },
      pagination: {
        showQuickJumper: !this.isMobile(),
        showSizeChanger: !this.isMobile(),
        showTotal: (total, range) => {
          return this.isMobile() ? null : (range[0] + "-" + range[1] + " 共" + total + "条")
        },
      },
      toggleSeniorTool: false,
      username: localStorage.getItem('username'),
      columns: this.getColumns(),
      sorter: {
        column: 'updateTime',
        order: 'desc',
      },
      url: {
        list: window._CONFIG['domainURL'] + "/usAppointment/list",
        apply: window._CONFIG['domainURL'] + "/usAppointment/apply",
        ready: window._CONFIG['domainURL'] + "/usAppointment/ready",
        init: window._CONFIG['domainURL'] + "/usAppointment/init",
        stop: window._CONFIG['domainURL'] + "/usAppointment/stop",
        finish: window._CONFIG['domainURL'] + "/usAppointment/finish",
        pause: window._CONFIG['domainURL'] + "/usAppointment/pause",
        deletes: window._CONFIG['domainURL'] + "/usAppointment"
      }
    }
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  methods: {
    getColumns() {
      let username = localStorage.getItem('username');
      let result = [];
      if (username.indexOf('super') !== -1 || username.indexOf('admin') !== -1) {
        result.push({
          title: '状态',
          align: "center",
          dataIndex: 'status',
          filters: [
            {text: '开始', value: '开始'},
            {text: '准备', value: '准备'},
            {text: '预约', value: '预约'},
            {text: '成功', value: '成功'},
            {text: '暂停', value: '暂停'},
            {text: '停止', value: '停止'},
          ],
          width: 120,
          fixed: this.isMobile() ? false : 'left',
          scopedSlots: {customRender: 'status'}
        })
      }
      result = result.concat([
        {
          title: '姓名',
          align: "center",
          dataIndex: 'name',
          fixed: this.isMobile() ? false : 'left',
          scopedSlots: {customRender: 'name'},
          width: 150
        },
        {
          title: '账号',
          align: "center",
          dataIndex: 'account',
          width: 200
        },
        {
          title: 'password',
          align: "center",
          dataIndex: 'password',
          width: 200
        },
        {
          title: '签证类型',
          align: "center",
          dataIndex: 'type',
          filters: [
            {text: 'B1/B2', value: 'B1/B2'},
            {text: 'B2', value: 'B2'},
            {text: 'B1', value: 'B1'},
            {text: 'F-1', value: 'F-1'},
            {text: 'F-2', value: 'F-2'},
            {text: 'L-1 (Blanket)', value: 'L-1 (Blanket)'},
            {text: 'L-1 (Individual)', value: 'L-1 (Individual)'},
            {text: 'L-2 (Blanket)', value: 'L-2 (Blanket)'},
            {text: 'L-2 (Individual)', value: 'L-2 (Individual)'},
            {text: 'H-1B', value: 'H-1B'}
          ],
          width: 150
        },
        {
          title: '签证领区',
          align: "center",
          dataIndex: 'area',
          width: 150,
          filters: [
            {text: 'SINGAPORE', value: 'SINGAPORE'},
            {text: 'BEIJING', value: 'BEIJING'},
            {text: 'SHANGHAI', value: 'SHANGHAI'},
            {text: 'GUANGZHOU', value: 'GUANGZHOU'},
            {text: 'SHENYANG', value: 'SHENYANG'},
            {text: 'WUHAN', value: 'WUHAN'},
            {text: 'BERLIN', value: 'BERLIN'},
          ],
        },
        {
          title: '创建时间',
          align: "center",
          dataIndex: 'createTime',
          sorter: true,
          width: 200
        },
        {
          title: '备注',
          align: "center",
          dataIndex: 'remark',
          width: 200
        }
      ])
      if (username.indexOf('super') !== -1 || username.indexOf('admin') !== -1) {
        result = result.concat([
          {
            title: '预约时间',
            align: "center",
            dataIndex: 'applicantTime',
            width: 220
          },
          {
            title: '修改时间',
            align: "center",
            dataIndex: 'updateTime',
            width: 220
          },
          {
            title: '所有者',
            align: "center",
            dataIndex: 'user',
            width: 150
          },
          {
            title: '预约操作员',
            align: "center",
            dataIndex: 'operator',
            width: 150
          }
        ])
      }
      result = result.concat([
        {
          title: '预约开始日期',
          align: "center",
          dataIndex: 'applicantStart',
          sorter: true,
          fixed: this.isMobile() ? false : 'right',
          width: 150
        },
        {
          title: '预约最后日期',
          align: "center",
          dataIndex: 'applicantEnd',
          sorter: true,
          fixed: this.isMobile() ? false : 'right',
          width: 150
        }
      ])
      result = result.concat([
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 120,
          scopedSlots: {customRender: 'action'},
          align: "center",
        }
      ])

      return result;
    },
    search: debounce(function () {
      this.pagination.current = 1;
      this.loadData();
    }, 800),

    handleAdd: function () {
      this.$refs.createModal.show('新增', {});
    },
    handleEdit(record) {
      this.$refs.createModal.show('编辑', record);
    },
    handleApply(record) {
      let that = this;
      that.loading = true;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
          } else {
            that.$message.error(response.msg);
          }
          that.loadData();
        }
      };
      that.$axios.put(that.url.apply, {id: record.id}, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
          .finally(() => {
            that.loading = false;
          });
    },
    handleReady(record) {
      let that = this;
      that.loading = true;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
          } else {
            that.$message.error(response.msg);
          }
          that.loadData();
        }
      };
      that.$axios.put(that.url.ready, {id: record.id}, {headers: that.headers}).then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
          .finally(() => {
            that.loading = false;
          });
    },
    handleDeletes() {
      let that = this;
      that.loading = true;
      let ids = that.selectedRowKeys.toString();
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
            that.loadData();
          } else {
            that.$message.error(response.msg);
          }
        }
      };
      that.$axios.delete(that.url.deletes + "?ids=" + ids, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
          .finally(() => {
            that.loading = false;
          });
    },
    handleInit: function (record) {
      let that = this;
      that.loading = true;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
            that.loadData();
          } else {
            that.$message.error(response.msg);
          }
        }
      };
      that.$axios.put(that.url.init, {id: record.id}, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
          .finally(() => {
            that.loading = false;
          });
    },
    handleStop: function (record) {
      let that = this;
      that.loading = true;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
            that.loadData();
          } else {
            that.$message.error(response.msg);
          }
        }
      };
      that.$axios.put(that.url.stop, {id: record.id}, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
          .finally(() => {
            that.loading = false;
          });
    },

    handlePause: function (record) {
      let that = this;
      that.loading = true;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
            that.loadData();
          } else {
            that.$message.error(response.msg);
          }
        }
      };
      that.$axios.put(that.url.pause, {id: record.id}, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
          .finally(() => {
            that.loading = false;
          });
    },

    handleFinish: function (record) {
      let that = this;
      that.loading = true;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
            that.loadData();
          } else {
            that.$message.error(response.msg);
          }
        }
      };
      that.$axios.put(that.url.finish, {
        id: record.id,
        applicantTime: '手动操作'
      }, {headers: that.headers}).then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
          .finally(() => {
            that.loading = false;
          });
    },
    handleTool() {
      this.toggleSeniorTool = !this.toggleSeniorTool;
      if (this.toggleSeniorTool === false) {
        delete this.queryParam.applicantDate;
        this.loadData();
      }
    },
  },
  mounted() {
    let that = this;
    if (this.$route.query.id) {
      const handleSuccess = (res) => {
        if (res) {
          that.$refs.createModal.show('新增', res.data);
        }
      };
      that.$axios.get(that.url.getForDs + "?dsId=" + this.$route.query.id, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
    }
  },
  created() {
    this.loadData();
  }
}
</script>
